$(() => {
  const $window = $(window);
  const $html = $("#html");
  const $body = $("body");
  const $header = $("#header");
  const $navigation = $("#navigation-mobile");

  let $open = $('[data-navigation="open"]');
  let $close = $('[data-navigation="close"]');

  $open.click(function (evt) {
    evt.preventDefault();
    evt.stopPropagation();

    $body.addClass('navigation-visible');
    $navigation.removeAttr("aria-hidden");
  });

  $close.click(function (evt) {
    evt.preventDefault();
    evt.stopPropagation();

    $body.removeClass('navigation-visible');
    $navigation.prop("aria-hidden", true);
  });

  // On mobile a click event wont work, replace this with a click outside the popover

  if (Modernizr.touchevents) {

    $(".navigation .has-submenu > a", $header).click(evt => {
      evt.preventDefault();
      evt.stopPropagation();

      $(evt.currentTarget).closest('li').toggleClass('toggle-submenu');

      return false;
    });

    $(".navigation-mobile-wrapper a", $body).click(evt => {
      if ($window.width() < 1024) {
        // On mobile close the navigation / because some URLS
        // may contain a HASH # and they won't close
        $body.removeClass('navigation-visible');
      }
    });
  }
});


// WEBPACK FOOTER //
// ./js/navigation.js